// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledSelectIcon =
  exports.StyledSelectListActionButton =
  exports.StyledSelectListButtonsWrapper =
  exports.StyledSelectList =
  exports.StyledSelect =
    void 0;

var _styledComponents = _interopRequireWildcard(require('styled-components'));

var _colors = require('../../utils/colors');

var _List = require('../List');

var _Icon = require('../Icon');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject9() {
  var data = _taggedTemplateLiteral([
    '\n  font-size: calc(4 / 3 * 1rem);\n  display: flex;\n  align-items: center;\n  ',
    '\n'
  ]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(['\n  padding: 0;\n  ', ' \n  ', ' \n']);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([
    '\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  background: ',
    ";\n  padding: .5rem;\n  :before {\n    position: absolute;\n    top: 0;\n    left: .5em;\n    right: .5em;\n    content: '';\n    height: 1px;\n    background: ",
    ';\n  }\n'
  ]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([
    '\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0;\n  z-index: 1;\n  cursor: initial;\n  overflow-y: auto;\n  max-height: 12.6em;  \n  ',
    '\n\n  @media screen and (min-width: ',
    ') {\n    max-height: 25.2em;\n  }\n'
  ]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([
    '\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  outline: none;\n  margin: 0;\n  padding: ',
    ';\n  width: ',
    ';\n  font-size: inherit;\n  text-align: left;\n  border: ',
    ';\n  border-radius: ',
    ';\n  background: ',
    ';\n\n  ',
    ' \n  ',
    '\n  ',
    '\n'
  ]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(['\n  transition: transform .15s linear;\n  ', '\n  ', '\n']);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(['\n    ', '\n  ']);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(['\n    :focus {\n      border-color: ', ';\n    }\n  ']);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(['\n    &:hover {\n      cursor: pointer;\n      border-color: ', ';\n    }\n  ']);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var hoverStyle = function hoverStyle(props) {
  return (0, _styledComponents.css)(
    _templateObject(),
    (0, _colors.normaliseColor)(props.theme.select.border.hoverColor, props.theme)
  );
};

var focusStyle = function focusStyle(props) {
  return (0, _styledComponents.css)(
    _templateObject2(),
    (0, _colors.normaliseColor)(props.theme.select.border.focusColor, props.theme)
  );
};

var listPosition = function listPosition(props) {
  return (0, _styledComponents.css)(
    _templateObject3(),
    props.listPosition === 'top'
      ? 'bottom: calc(100% + '.concat(props.theme.select.border.width, ');')
      : 'top: calc(100% + '.concat(props.theme.select.border.width, ');')
  );
};

var AnimationArrowRotation = (0, _styledComponents.css)(
  _templateObject4(),
  function (props) {
    return props.open && '\n    transform: rotate(-180deg);\n  ';
  },
  function (props) {
    return !props.open && '\n    transform: rotate(0deg);\n  ';
  }
);

var StyledSelect = _styledComponents.default.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['width', 'borderColor', 'disabled'].includes(prop);
  }
})(
  _templateObject5(),
  function (props) {
    return props.theme.select.padding;
  },
  function (props) {
    return props.width;
  },
  function (props) {
    return ''
      .concat(props.theme.select.border.width, ' ')
      .concat(props.theme.select.border.style, ' ')
      .concat(props.borderColor || (0, _colors.normaliseColor)(props.theme.select.border.color, props.theme));
  },
  function (props) {
    return props.theme.select.border.radius;
  },
  function (props) {
    return (0, _colors.normaliseColor)(props.theme.select.background.color, props.theme);
  },
  function (props) {
    return props.disabled && 'opacity: 0.3;';
  },
  function (props) {
    return !props.disabled && hoverStyle(props);
  },
  function (props) {
    return !props.disabled && focusStyle(props);
  }
);

exports.StyledSelect = StyledSelect;
var StyledSelectList = (0, _styledComponents.default)(_List.List).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['listPosition'].includes(prop);
  }
})(
  _templateObject6(),
  function (props) {
    return listPosition(props);
  },
  function (props) {
    return props.theme.breakpoints && props.theme.breakpoints.xl;
  }
);
exports.StyledSelectList = StyledSelectList;

var StyledSelectListButtonsWrapper = _styledComponents.default.div(
  _templateObject7(),
  function (props) {
    return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
  },
  function (props) {
    return (0, _colors.normaliseColor)(props.theme.list.border.color, props.theme);
  }
);

exports.StyledSelectListButtonsWrapper = StyledSelectListButtonsWrapper;

var StyledSelectListActionButton = _styledComponents.default.a.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['disabled'].includes(prop);
  }
})(
  _templateObject8(),
  function (props) {
    return props.disabled && 'opacity: 0.3;';
  },
  function (props) {
    return !props.disabled && 'cursor: pointer;';
  }
);

exports.StyledSelectListActionButton = StyledSelectListActionButton;
var StyledSelectIcon = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'open';
  }
})(_templateObject9(), AnimationArrowRotation);
exports.StyledSelectIcon = StyledSelectIcon;
